// extracted by extract-css-chunks-webpack-plugin
module.exports = {"footer":"css-2nhzBA1RlN","footer_about":"css-1ID16gm-EL","footer_index":"css-oi0cD3zIRi"};